import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import Main from '@/views/MainPage.vue'
const routes = [{
    path: "/",
    redirect: "/home",
    name: "Main",
    component: Main,
    children: [{
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          tabBar: true,
          keepAlive: true
        }
      },
      {
        path: "/home/book-detail",
        name: "book-detail",
        component: () => import("@/views/home/page/book-detail.vue"),
      },
      {
        path: "/ancient-poetry",
        name: "ancient-poetry",
        component: () => import("@/views/ancient-poetry/index.vue"),
        meta: {
          tabBar: true,
          keepAlive: true
        }
      },
      {
        path: "/ancient-poetry/detail",
        name: "ancient-poetry-detail",
        component: () => import("@/views/ancient-poetry/page/poetry-detail.vue"),
      },
      {
        path: "famous/detail",
        name: "famous-detail",
        component: () => import("@/views/ancient-poetry/page/famous-detail.vue"),
      },
      {
        path: "/novel",
        name: "novel",
        component: () => import("@/views/novel/index.vue"),
        meta: {
          tabBar: true,
          keepAlive: true
        }
      },
      {
        path: "/mine",
        name: "Mine",
        component: () => import("@/views/mine/index.vue"),
        meta: {
          tabBar: true,
          keepAlive: true
        }
      },
      {
        path: "/mine/book",
        name: "collected-book",
        component: () => import("@/views/mine/page/collected-book.vue"),
      },
      {
        path: "/mine/poetry",
        name: "collected-poetry",
        component: () => import("@/views/mine/page/collected-poetry.vue"),
      },
      {
        path: "/mine/famous",
        name: "collected-famous",
        component: () => import("@/views/mine/page/collected-famous.vue"),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/AppLoginPage.vue'),
    meta: {
      parent: "",
      title: "登录",
      ignoreAuth: true,
    },
  },

  {
    path: '/404',
    component: () => import('@/views/ErrorPath.vue'),
    meta: {
      parent: "",
      title: "404界面",
      ignoreAuth: true,
    },
  },


];



const router = createRouter({
  history: createWebHistory(), //hasn路由
  // history: createWebHashHistory(),
  routes,
});

// 前置路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0 && !to.name) {
    next({
      path: '/404'
    });
  } else if (!localStorage.getItem('token') && to.path !== '/login') {

    next({
      path: '/login'
    });
  } else {
    next();
  }
});

export default router;